import Cookies from "js-cookie";

let logoutTimer  = null ;
const calculateRemainingTime = (remainingTime) => {
    const currentTime = new Date().getTime();
    const expirationTime = new Date(remainingTime).getTime();
   
    return expirationTime - currentTime;
}
const LogoutHandler = () => {
    Cookies.set("studentportaltoken" , "");
   
   window.location.reload();
    if(logoutTimer){
        clearTimeout(logoutTimer);
    }
}


export const setTokenExpiration = (decodedToken)=>{
    let remainingTime = calculateRemainingTime(decodedToken.exp * 1000);
   
   logoutTimer=  setTimeout(LogoutHandler, remainingTime)
}
